import classNames from "classnames";
import "./JSONHandler.scss";
import { useSharedState } from "../../../../components/services/WindowSizeService";
import { useState } from "react";
import { IUpdateLicense } from "../UpdateLicense/interface";
import LoginModal from "../../LoginModal/LoginModal";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClipboard } from "@fortawesome/free-solid-svg-icons";
const JSONHandler = (props: IUpdateLicense) => {
    const { onClose } = props;
    const windowSize$: any = useSharedState();
    const [getJSONFlag, setGetJSONFlag] = useState<boolean>(false);
    const [gotJSONFlag, setGotJSONFlag] = useState<boolean>(false);
    const [postJSONFlag, setPostJSONFlag] = useState<boolean>(false);
    const [handleConfigJSON, setHandleConfigJSON] = useState<any>();
    const [submitFlag, setSubmitFlag] = useState<boolean>(false);
    const [hasPostInput, setHasPostInput] = useState<boolean>(false);
    const [JsonType, setJsonType] = useState<string>();
    const [inputs, setInputs] = useState<any>({
        postJSONInput: ""
    });
    const closeModal = () => {
        setGetJSONFlag(false);
        setPostJSONFlag(false);
        setHasPostInput(false);
    }
    const [copied, setCopied] = useState<boolean>(false);

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs((values: any) => ({ ...values, [name]: value }))
    }

    // useEffect(() => {
    //     console.log(inputs);
    // }, [inputs])

    const onCopy = () => {
        setCopied(true);
    }

    const onSavePost = () => {
        setSubmitFlag(true);
        if (inputs?.postJSONInput) {
            const temp: any = JsonType;
            postJSON(temp);
            setHasPostInput(true);
        }
    }

    const getJSON = (parent: string) => {
        setGetJSONFlag(true);
        setJsonType(parent);
    }

    const postJSON = (parent: string) => {
        setPostJSONFlag(true);
        setJsonType(parent);
    }

    return (
        <div className="json-handler">
            <div className={classNames("modal-body py-3 events-none",
                {
                    "drawer-body": windowSize$ === "sm" || windowSize$ === "xs",
                    "dr": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                })}>

                {getJSONFlag &&
                    <LoginModal
                        onClose={closeModal}
                        setHandleConfigJSON={setHandleConfigJSON}
                        setGotJSONFlag={setGotJSONFlag}
                        jsonType={JsonType}
                    />
                }
                {
                    hasPostInput &&
                    <LoginModal
                        type="post"
                        postInput={inputs?.postJSONInput}
                        onClose={closeModal}
                        jsonType={JsonType}
                    />
                }
                {
                    postJSONFlag || gotJSONFlag ?
                        <div>
                            <div className="d-flex" style={{ height: '50px' }}>
                                <label className="mb-2">
                                    {postJSONFlag ?
                                        "POST JSON : " :
                                        "JSON DATA : "
                                    }
                                </label>
                                {gotJSONFlag && handleConfigJSON &&
                                    <div className="clipboard-copy">
                                        <CopyToClipboard text={handleConfigJSON}
                                            onCopy={onCopy}>
                                            <button className="btn btn-primary">
                                                {copied ?
                                                    <>
                                                        Copied to Clipboard
                                                        <FontAwesomeIcon className="ml-2" icon={faCheck} />
                                                    </> :
                                                    <>
                                                        Copy to clipboard
                                                        <FontAwesomeIcon className="ml-2" icon={faClipboard} />
                                                    </>
                                                }
                                            </button>
                                        </CopyToClipboard>
                                    </div>
                                }
                            </div>
                            {gotJSONFlag && handleConfigJSON ?
                                <>
                                    <textarea
                                        typeof="text"
                                        className="form-control text-box textbox-log"
                                        value={handleConfigJSON}
                                        id="getJSON"
                                        rows={15}
                                        readOnly
                                    >
                                    </textarea>
                                </>
                                :
                                <>
                                    <textarea
                                        typeof="text"
                                        name="postJSONInput"
                                        value={inputs?.postJSONInput}
                                        className="form-control text-box textbox-log"
                                        id="postJSON"
                                        onChange={handleChange}
                                        rows={15}
                                    >
                                    </textarea>
                                    {submitFlag && !inputs?.postJSONInput &&
                                        <div className="text-danger m-2">Please Enter JSON</div>
                                    }
                                </>
                            }
                        </div>
                        :
                        <div className="row">
                            <div className="col-md-6">
                                <div className="border-box">
                                    <h3 className="card-heading mb-4">Config Json</h3>
                                    <div className="row mx-3">
                                        <div className="col-md-12 col-lg-6 col-6 col-sm-12 mb-sm-2">
                                            <button type="button" className="btn btn-primary ml-3 w-100" onClick={() => { getJSON("config") }}>Get Json</button>
                                        </div>
                                        <div className="col-md-12 col-lg-6 col-6 col-sm-12">
                                            <button type="button" className="btn btn-primary ml-3 w-100" onClick={() => { postJSON("config") }}>Post Json</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="border-box">
                                    <h3 className="card-heading mb-4">Acq Json</h3>
                                    <div className="row mx-3">
                                        <div className=" col-md-12 col-lg-6 col-6 col-sm-12 mb-sm-2">
                                            <button type="button" className="btn btn-primary ml-3 w-100" onClick={() => { getJSON("acq") }}>Get Json</button>
                                        </div>
                                        <div className="col-md-12 col-lg-6 col-6 col-sm-12">
                                            <button type="button" className="btn btn-primary ml-3 w-100" onClick={() => { postJSON("acq") }}>Post Json</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div >
                }
            </div >
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={() => { onClose && onClose(false) }}>Close</button>
                    {postJSONFlag &&
                        <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" onClick={() => { onSavePost() }}>Save</button>
                    }
                </div>
            </div>
        </div>
    )
}
export default JSONHandler;